/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MapComponent from './MapComponent/MapComponent';
import './ListViewLeftPart.sass';

class ListViewLeftPart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      staticImageAvailable: true,
      isMapHovering: false,
    };

  }

  componentDidMount() {
    this.props.mapUrlLv ? this.setState({ staticImageAvailable: true }) : this.setState({ staticImageAvailable: false });
    this.props.onComponentDidMount(this.props.area.id, this.props.kind);
  }

  handleMapMouseHover = ({ target }) => {
    if (!this.state.isMapHovering) {
      target.style.background = 'white';
      this.setState({ isMapHovering: true });
    }
  };

  render() {
    const { arealist, title, descTeaser, mapUrlLv } = this.props;
    const {staticImageAvailable, isMapHovering} = this.state;

    const mapContainerStyle = {
      position: 'absolute',
      objectFit: 'cover',
      width: '100%',
      height: '400px'
    };

    return (
      <div className="leftPart">
        <div className="readMoreContainer">
          <h1 className="main-color bold">
            {title}
          </h1>
        </div>
        <p>
          {descTeaser}
        </p>

        <div
          className="map-wrapper"
          onMouseEnter={this.handleMapMouseHover}
          onTouchStart={this.handleMapMouseHover}
        >
          {staticImageAvailable &&
            <img
              className='bottom-location-map lazyload'
              src={mapUrlLv}
              data-sizes="auto"
              style={mapContainerStyle}
            />
          }

          { (isMapHovering || !staticImageAvailable) &&
            <MapComponent />
          }
        </div>
        <div className="map-list">
          {arealist.map(elem => (
            <ul key={elem.province_name}>
              <li><strong><a href={elem.province_url}>{elem.province_name}</a></strong></li>
              {elem.cities.map(cities => (
                <li key={cities.city_name}>
                  <a href={cities.city_url}>{cities.city_name}</a>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    );
  }
}

ListViewLeftPart.propTypes = {
  area: PropTypes.oneOfType([PropTypes.object]),
  onComponentDidMount: PropTypes.func,
  arealist: PropTypes.arrayOf(PropTypes.shape),
};

ListViewLeftPart.defaultProps = {
  area: {},
  onComponentDidMount: () => null,
  arealist: [],
};


export default ListViewLeftPart;
